<template>
  <div>
    <v-row no-gutters>
      <v-card-title class="font-weight-light ml-4 text-subtitle-1 secondary--text">
        Cliquez sur la rubrique qui vous intéresse pour trouver ce que vous recherchez.
      </v-card-title>
    </v-row>
    <v-row
      v-if="!$vuetify.breakpoint.mobile"
      no-gutters
    >
      <v-col
        cols="auto"
        align-self="start"
        class="mt-5"
      >
        <v-list>
          <v-list-item
            v-for="faqTheme in faqThemes"
            :key="faqTheme.id"
            :class="isThemeSelected(faqTheme.id) ? 'theme-selected' : 'theme'"
            @click="selectTheme(faqTheme)"
          >
            <v-row justify-center>
              <v-col
                cols="auto"
                align-self="center"
              >
                <v-list-item-title
                  class="text-h5 font-weight-bold"
                  :class="isThemeSelected(faqTheme.id) ? 'theme-selected-color' : 'grey--text text--darken-2'"
                  v-text="faqTheme.libelle"
                />
              </v-col>
              <v-col
                cols="auto"
                class="mr-auto"
                align-self="center"
              >
                <v-chip
                  v-if="isThemeHasAtLeastOneNouveaute(faqTheme)"
                  class="ml-2"
                  color="red"
                  text-color="white"
                >
                  <span class="pr-0 pr-md-1">
                    nouveautés!
                  </span>
                </v-chip>
              </v-col>
              <v-col
                cols="auto"
                align-self="center"
              >
                <v-list-item-action>
                  <v-icon
                    v-if="isThemeSelected(faqTheme.id)"
                    class="theme-selected-color"
                  >
                    mdi-menu-right
                  </v-icon>
                  <v-icon
                    v-else
                    class="theme-color"
                  >
                    mdi-menu-down
                  </v-icon>
                </v-list-item-action>
              </v-col>
            </v-row>
          </v-list-item>
        </v-list>
      </v-col>
      <v-col align-self="start">
        <FaqQuestionsReponses
          v-if="isAffichageQuestionsReponses"
          :theme="themeSelected"
          @refreshNouveauteTheme="hasAtLeastOneNouveaute(themeSelected)"
        />
      </v-col>
    </v-row>
    <FaqVueMobile
      v-else
      :faq-themes="faqThemes"
    />
  </div>
</template>

<script>
import FaqQuestionsReponses from './faq-question-reponse.vue'
import FaqVueMobile from './faq-vue-mobile.vue'
import {clone} from '@/utils/clone'
import faqService from '@/service/faq.service'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'FaqThemesUtilisateur',
  components: { FaqQuestionsReponses, FaqVueMobile },
  props: {
    faqThemes: {
      type: Array,
      required: true
    },
  },

  data () {
    return {
      isAffichageQuestionsReponses: false,
      themeSelected: {}
    }
  },

  computed: {
    ...mapGetters({
      themeHasAtLeastOneNouveaute: 'faq/themeHasAtLeastOneNouveaute'
    })
  },

  methods: {
    ...mapActions({
      getHasAtLeastOneNouveaute: 'faq/getHasAtLeastOneNouveaute'
    }),
    hasAtLeastOneNouveaute (theme) {
      this.getHasAtLeastOneNouveaute(theme)      
    },
    selectTheme (theme) {
      if (this.isAffichageQuestionsReponses && (this.themeSelected == null || theme.id === this.themeSelected.id)) {
        this.isAffichageQuestionsReponses = false
        this.themeSelected = null
      } else {
        this.isAffichageQuestionsReponses = true
        this.themeSelected = clone(theme)
      }
    },
    isThemeSelected (idTheme) {
      return this.themeSelected ? this.themeSelected.id === idTheme : false
    },
    isThemeHasAtLeastOneNouveaute (theme) {      
      let isChipNouveauteAffiche = false
      if (this.themeHasAtLeastOneNouveaute && this.themeHasAtLeastOneNouveaute.idTheme === theme.id) {
        isChipNouveauteAffiche = this.themeHasAtLeastOneNouveaute.isThemeHaveAtLeastOneNouveaute
      } else {
        isChipNouveauteAffiche = faqService.hasAtLeastOneNouveaute(theme)
      }      
      return isChipNouveauteAffiche
    }
  }
}
</script>

<style lang="scss" scoped>
.align-end {
  text-align: end;
}
.theme-color {
  color: #b2b2b2;
}
.theme-selected-color {
  color: #967a27;
}
</style>
